<template>
  <div
    id="page"
    class="row mx-auto justify-content-center align-items-center flex-column "
  >
    <div class="display-1">
      <i class="text-warning fa fa-exclamation" />
    </div>
    <div class="display-1">
      <b>404</b>
    </div>
    <div>This page doesn't exist</div>
    <div>
      <button
        type="button"
        class="btn btn-primary mt-4"
        @click="goBack()"
      >
        Go Back
      </button>
    </div>
  </div>
</template>

<script>
export default {
    name: '404',
    methods: {
        goBack() {
            this.$router.back()
        }
    }
}
</script>

<style scoped>
#page {
    margin-top: 15%;
}
</style>
